'use strict';

var _team = require('./team');

var _team2 = _interopRequireDefault(_team);

var _extend = require('lodash/object/extend');

var _extend2 = _interopRequireDefault(_extend);

var _recycle = require('common/models/utils/recycle');

var _recycle2 = _interopRequireDefault(_recycle);

var _faxLines = require('./fax-lines');

var _faxLines2 = _interopRequireDefault(_faxLines);

var _model = require('common/models/base/model');

var _model2 = _interopRequireDefault(_model);

var _signatures = require('./signatures');

var _signatures2 = _interopRequireDefault(_signatures);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _model2['default'].extend({

    signatures: void 0,
    settings: {},

    apiEndpointAlias: 'user',

    mixins: [require('common/models/mixins/model')],

    /**
    */

    getSignatures: function getSignatures(type) {

        if (!this.signatures) this.signatures = {};

        if (!this.signatures[type]) {
            this.signatures[type] = _signatures2['default'].create({
                type: type,
                notifier: this.notifier
            });
        }

        return this.signatures[type];
    },


    /**
     *
     */

    setSignatures: function setSignatures(type, signatures) {
        this.signatures = this.signatures || {};
        this.signatures[type] = signatures;
    },


    /**
    */

    getFirstName: function getFirstName() {
        return this.settings.firstName || '';
    },


    /**
    */

    getLastName: function getLastName() {
        return this.settings.lastName || '';
    },


    /**
    */

    getFullName: function getFullName() {
        return _hfReactHelper2['default'].trim(this.getFirstName() + ' ' + this.getLastName());
    },


    /**
    */

    setFullName: function setFullName(fullName) {
        if (fullName) {
            var parts = fullName.split(' ');
            this.settings.firstName = parts[0];
            this.settings.lastName = parts.slice(1).join(' ');
        } else {
            this.settings.firstName = null;
            this.settings.lastName = null;
        }
    },


    /**
    */

    getInitials: function getInitials() {
        var v = '';
        var fn = this.getFirstName();
        var ln = this.getLastName();
        if (fn) {
            v += fn[0];
        }
        if (ln) {
            v += ln[0];
        }
        return v.toUpperCase();
    },


    /**
    */

    getFaxLines: function getFaxLines() {

        if (!this._faxLines) {
            this._faxLines = _faxLines2['default'].create({
                user: this,
                notifier: this.notifier
            });
            this._faxLines.load();
        }

        return this._faxLines;
    },


    /**
    */

    getTeam: function getTeam() {

        if (!this._team) {
            this._team = _team2['default'].create({
                user: this,
                notifier: this.notifier
            });

            this._team.load();
        }

        return this._team;
    },


    /**
    */

    fromData: function fromData(data) {
        return {
            'emailAddress': data.emailAddress,
            'features': (0, _recycle2['default'])(this.features, _model2['default'], (0, _extend2['default'])({ user: this, notifier: this.notifier }, data.features))
        };
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/models/user.js
 ** module id = 490
 ** module chunks = 0 1
 **/